module.exports = __webpack_public_path__ + "static/media/Glasphalt_gv.16d1fc4f.pdf";